import styled from '@emotion/styled';
import { themeColors } from '../../../constants/themes';

export const RowFlex = styled('div')`
  display: flex;
`;

export const RowFlexReverse = styled('div')`
  display: flex;
  flex-direction: row-reverse;
`;

export const ColumnFlex = styled('div')`
  display: flex;
  flex-direction: column;
`;

export const Circle = styled('div')`
  min-width: 405px;
  max-width: 405px;
  height: 100%;
  border-radius: 100%;
  background-color: ${({ isDisabledByStep }) =>
    isDisabledByStep ? themeColors.backgroundDarkGray : themeColors.backgroundDarkBlue};
  position: relative;
  left: -265px;
  display: flex;
  justify-content: flex-end;
  padding-right: 20px;
`;

/*
left '-260' value calculated by =
270(Circle position) - 405(Circle Width)  =  -135
-135 - 25(Circle Padding) - 120(Step Description Width) =
 -280 + 30 ('Left Padding' of component) = 250
TODO: set as variables by scss
*/

export const StepDescription = styled('div')`
  position: relative;
  left: 150px;
  top: -208px;
  width: 92px;
  height: 64px;
  background-color: transparent;
  display: flex;
  text-align: left;
  align-items: center;
  font-size: 16px;
  color: ${({ isDisabledByStep }) =>
    isDisabledByStep ? themeColors.dirtyLightBlue : themeColors.darkBlue};
`;

export const DiscoverSection = styled('div')`
  display: flex;
  min-height: 385px;
  width: 100%;
  background-color: ${({ isDisabled }) =>
    isDisabled ? themeColors.backgroundDarkGray : themeColors.backgroundLightBlue};
  pointer-events: ${({ isDisabled }) => (isDisabled ? 'none' : 'auto')};
`;

export const DisableMask = styled('div')`
  width: 100%;
  height: 100%;
  background-color: ${themeColors.backgroundDarkGray};
  opacity: 0.8;
  position: absolute;
  z-index: 50;
  pointer-events: none;
  top: 0;
  left: 0;
  box-shadow: 0px 1px 7px 0 rgba(0, 105, 250, 0.15);
  border-radius: ${({ border }) => `${border}px`};
`;
